import { Typography } from "@mui/material"

export default function AssignmentPlaceHolder() {
    return (
        <div className="w-full p-2 bg-gray-100 relative flex flex-row items-center">
            <Typography sx={{fontSize: "12px", color: "#000", pl: "1rem", position: 'sticky', left: '1rem'}}>No assignments available</Typography>
        </div>
    )
}